import { SVGProps } from 'react';

const EmailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 2.75H2C1.80109 2.75 1.61032 2.82902 1.46967 2.96967C1.32902 3.11032 1.25 3.30109 1.25 3.5V12C1.25 12.3315 1.3817 12.6495 1.61612 12.8839C1.85054 13.1183 2.16848 13.25 2.5 13.25H13.5C13.8315 13.25 14.1495 13.1183 14.3839 12.8839C14.6183 12.6495 14.75 12.3315 14.75 12V3.5C14.75 3.30109 14.671 3.11032 14.5303 2.96967C14.3897 2.82902 14.1989 2.75 14 2.75ZM8 7.9825L3.92812 4.25H12.0719L8 7.9825ZM5.79938 8L2.75 10.795V5.205L5.79938 8ZM6.90938 9.0175L7.49312 9.55313C7.63146 9.67997 7.81232 9.75033 8 9.75033C8.18768 9.75033 8.36854 9.67997 8.50688 9.55313L9.09062 9.0175L12.0719 11.75H3.92812L6.90938 9.0175ZM10.2006 8L13.25 5.205V10.795L10.2006 8Z" fill="#71717A"/>
    </svg>

  );
};

export default EmailIcon;
